// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bpgN","left":"styles_left__1wWTU"};